import { createContext } from 'react';

import type { Context } from '../types/hotel-offers';

export const HotelOffersContext = createContext<Partial<Context>>({});
